import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateALesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CreateLessonList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/CreateList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllLessonsOfCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetASingleLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateASingleLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UploadLessonFiles extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/UploadFile");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class GetLessonMedias extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/GetFullLessonMediasBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteLessonMedias extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/DeleteLessonMediasBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class ChangeLessonsPriority extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/ChangePriority");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllLessonsV2 extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/GetAllLessonsV2");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteLessonFromCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/RemoveLessonCourseId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetOrderLessons extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/GetOrderLessons");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}


class GetOrderLessonsDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Lesson/GetOrderLessonsDetails");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  CreateALesson,
  CreateLessonList,
  GetAllLessonsOfCourse,
  GetASingleLesson,
  UpdateASingleLesson,
  UploadLessonFiles,
  GetLessonMedias,
  DeleteLessonMedias,
  ChangeLessonsPriority,
  GetAllLessonsV2,
  DeleteLessonFromCourse,
  GetOrderLessons,
  GetOrderLessonsDetails,
};
